import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FMSModel from '../../../../Models/FMS/FMS.Model';
import { NavBar } from '../../../../Models/NavBar/NavBar.Model';
import { FMSAPIColumn } from './Columns/FMSAPIColumn';
import { FMSSettingsColumn } from './Columns/FMSSettingsColumn';
import { Input, Spinner } from '@swivl-mono/ui';
import './FMSDetailsView.scss';

export default function FMSDetailsView() {
  const { isLoading, FMSs, isSavingFMS } = FMSModel.useState((s) => s);
  const id = useParams().id;
  const fms = FMSs?.find((fms) => fms.id === Number(id));
  const navigate = useNavigate();
  useEffect(() => {
    FMSModel.load(false);
  }, []);

  useEffect(() => {
    if (fms) {
      NavBar.set(
        <NavBar.Component.Back title="BACK TO SETTINGS" to="/settings/fms-integrations" />,
        <NavBar.Component.Title title={fms.type + ' Integration'} />,
        <>
          {/* {fms.get("isDefault") ? <span style={{cursor:"not-allowed", color:"#A8A4A2", fontWeight:"bold"}}>IS DEFAULT</span> : <NavBar.Component.Button title="MAKE DEFAULT" isLoading={isSavingFMS} onClick={() => {
                FMSModel.setAsDefault(fms)
              }} />} */}
          <NavBar.Component.Button
            type="warning"
            title="REMOVE INTEGRATION"
            onClick={() => {
              if (window.confirm('Are you sure you want to remove this integration?')) {
                navigate('/settings/fms-integrations');
                FMSModel.deleteFMS(fms);
              }
            }}
          />
        </>,
        fms.type + ' Integration'
      );
    }
  }, [fms, isSavingFMS, isLoading, FMSs]);

  if (!fms) {
    return (
      <div className="FMSDetailsView">
        <Spinner />
      </div>
    );
  }

  const onNameChange = (e) => {
    const value = e.target.value;

    fms.name = value;

    FMSModel.updateFMS(fms, false);
  };

  const onTokenChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const token = fms.token || {};

    token[name] = value;
    fms.token = token;

    FMSModel.updateFMS(fms, false);
  };

  const onDataChange = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    const data = fms.data || {};

    data[name] = value;
    fms.data = data;

    FMSModel.updateFMS(fms, false);
  };

  const onBlur = () => {
    FMSModel.updateFMS(fms, true);
  };

  const onSwitch = (name, value) => {
    const data = fms.data || {};

    data[name] = value;
    fms.data = data;

    FMSModel.updateFMS(fms, true);
  };

  const onSliderChange = (value) => {
    const data = fms.data || {};

    data.smallMaxSize = value[0].value;
    data.mediumMaxSize = value[1].value;
    data.largeMaxSize = value[2].value;

    fms.data = data;
    FMSModel.updateFMS(fms, false);
  };

  return (
    <div className="FMSDetailsView">
      <div className="leftColumn">
        <div className="siteSection">
          <h2>Integration Name</h2>
          This helps keep track of this integration when using multiple FMS integrations.
          <Input onChange={onNameChange} name="name" value={fms.name} onBlur={onBlur} />
        </div>

        <FMSSettingsColumn fms={fms} onBlur={onBlur} onDataChange={onDataChange} onSliderChange={onSliderChange} onSwitch={onSwitch} />
      </div>
      <div className="rightColumn">
        <FMSAPIColumn fms={fms} onTokenChange={onTokenChange} onBlur={onBlur} onDataChange={onDataChange} />
      </div>
    </div>
  );
}
